var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelepon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.67 11.701a7.908 7.908 0 003.66 3.645.742.742 0 00.735-.056l2.347-1.565a.75.75 0 01.711-.065l4.391 1.882a.748.748 0 01.45.778 4.501 4.501 0 01-4.464 3.93A12.75 12.75 0 013.75 7.5a4.5 4.5 0 013.93-4.464.747.747 0 01.778.45l1.884 4.394a.751.751 0 01-.062.706L8.72 10.97a.743.743 0 00-.05.731v0z",
    stroke: "#232323",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgTelepon;